<template>
  <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11 1V21.9091" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"/>
    <path d="M21.9091 11H1" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"/>
  </svg>
</template>

<script>
export default {}
</script>
